import styled from 'styled-components'

import { darkGrey, white, skyBlue, grey, darkBlue } from '../../../styles/settings/colors'
import {
  title20GalanoBold,
  txt12OpenSans,
  txt12OpenSansLight,
  txt20OpenSans
} from '../../../styles/settings/types'

import rem from '../../../styles/tools/rem'

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InvoiceValue = styled.div`
  margin: ${rem('15px')} ${rem('15px')} 0 ${rem('15px')};
`

export const ValueLabel = styled.span`
  ${txt12OpenSansLight};
  color: ${darkGrey};
  display: inline-block;
  line-height: 1;
  margin-bottom: ${rem('4px')};
  text-align: left;
  text-transform: uppercase;
`

export const Details = styled.div`
  margin: ${rem('15px')};
  color: ${darkBlue};
  text-align: left;
  display: flex;
  flex-direction: column;
  ${txt12OpenSans}
  span {
      font-weight: bold;
    }
  }
  p {
    margin: 0;
  }
`

export const Currency = styled.p`
  ${title20GalanoBold};

  color: ${({ lightBlue }) => (lightBlue ? skyBlue : darkBlue)};
  display: flex;
  justify-content: flex-end;
  letter-spacing: 0;
  line-height: 1em;
  margin: 0;
  padding-bottom: ${rem('15px')};
  padding-top: ${rem('15px')};

  span {
    ${txt20OpenSans};
    margin-right: ${rem('3px')};
  }
`

export const Container = styled.section`
  background-color: ${white};
  border-radius: ${rem('4.4px')};
  border: solid ${rem('1px')} ${grey};
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/app/elements/DashboardInvoiceCard/styles.js